(function() { window.GUID_51696fe7_36cd_425c_8408_e9dc8a653db9 = { getGuid: function() { return "51696fe7-36cd-425c-8408-e9dc8a653db9"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TabMenu {
            static get instance() {
                if (!TabMenu._instance) {
                    TabMenu._instance = new TabMenu();
                }
                return TabMenu._instance;
            }
            constructor() {
                var _a, _b;
                this.state = "ready";
                this.isDebug = false;
                this.isDebug = (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsDebug()) !== null && _b !== void 0 ? _b : false;
            }
            /**
             * Binds tabs to content by adding an event listener on scroll with a 250ms delay (to prevent performance issues).
             * On scroll, the most visible content will be highlighted in the tab menu. On click on a tab, the content will be scrolled into view.
             * @param params The tab and content selectors.
             */
            static bindTabsToContent(params) {
                const { instance } = TabMenu;
                instance.bindTabsToContent(params);
            }
            static unbindTabsFromContent() {
                const { instance } = TabMenu;
                instance.unbindTabsFromContent();
            }
            unbindTabsFromContent() {
                try {
                    if (this.isDebug) {
                        this.log(`Unbinding tabs from content...`);
                    }
                    this.unbindScrollEvent();
                    this.unbindClickEvents();
                    this.items = [];
                    this.state = "ready";
                }
                catch (error) {
                    console.error("Error while disposing tab menu", error);
                }
            }
            bindTabsToContent(params) {
                try {
                    if (this.isDebug) {
                        this.log(`Binding tabs to content...`);
                    }
                    const $tabs = $(`${params.map((x) => x.tabSelector).join(", ")}`);
                    if (!$tabs.length) {
                        if (this.isDebug) {
                            this.log(`No tabs found, aborting.`);
                        }
                        return;
                    }
                    const $parentTabMenu = $tabs.first().closest(".tabmenu.control-cs");
                    if (!$parentTabMenu.length) {
                        if (this.isDebug) {
                            this.log(`No parent tab menu found, aborting.`);
                        }
                        return;
                    }
                    const allSameTabMenu = $tabs
                        .toArray()
                        .every((x) => $(x).closest(".tabmenu.control-cs").is($parentTabMenu));
                    if (!allSameTabMenu) {
                        if (this.isDebug) {
                            this.log(`Not all tabs are in the same tab menu, aborting.`);
                        }
                        return;
                    }
                    this.state = "ready";
                    this.items = params;
                    this.bindScrollEvent();
                    // this.bindClickEvents();
                }
                catch (error) {
                    console.error("Error while binding tabs to content", error);
                }
            }
            bindScrollEvent() {
                try {
                    if (this.isDebug) {
                        this.log(`Binding scroll event...`);
                    }
                    document.addEventListener("scroll", this.onScroll);
                    if (this.isDebug) {
                        this.log(`Scroll event bound.`);
                    }
                }
                catch (error) {
                    console.error("Error while binding scroll event", error);
                }
            }
            unbindScrollEvent() {
                try {
                    if (this.isDebug) {
                        this.log(`Unbinding scroll event...`);
                    }
                    document.removeEventListener("scroll", this.onScroll);
                    if (this.isDebug) {
                        this.log(`Scroll event unbound.`);
                    }
                }
                catch (error) {
                    console.error("Error while unbinding scroll event", error);
                }
            }
            bindClickEvents() {
                try {
                    if (this.isDebug) {
                        this.log(`Binding click events...`);
                    }
                    for (let i = 0; i < this.items.length; i++) {
                        const item = this.items[i];
                        const $tab = $(item.tabSelector);
                        $tab.offon("click.TabMenu", (e) => this.onTabClick(e, item));
                    }
                    if (this.isDebug) {
                        this.log(`Click events bound.`);
                    }
                }
                catch (error) {
                    console.error("Error while binding click events", error);
                }
            }
            unbindClickEvents() {
                try {
                    if (this.isDebug) {
                        this.log(`Unbinding click events...`);
                    }
                    if (this.items && this.items.length) {
                        for (let i = 0; i < this.items.length; i++) {
                            const item = this.items[i];
                            const $tab = $(item.tabSelector);
                            $tab.off("click.TabMenu", (e) => this.onTabClick(e, item));
                        }
                        if (this.isDebug) {
                            this.log(`Click events unbound.`);
                        }
                    }
                    else {
                        if (this.isDebug) {
                            this.log(`No items found, aborting.`);
                        }
                    }
                }
                catch (error) {
                    console.error("Error while unbinding click events", error);
                }
            }
            onTabClick(event, item) {
                try {
                    if (this.isDebug) {
                        this.log(`Handling tab click...`);
                    }
                    const $content = $(item.contentSelector);
                    if (!$content.length) {
                        if (this.isDebug) {
                            this.log(`No content found, aborting.`);
                        }
                        return;
                    }
                    this.unbindScrollEvent();
                    const $topbar = $("#section-top");
                    const $subTopbar = $("#section-sub-top");
                    let topHeight = $topbar.outerHeight();
                    if ($subTopbar.length)
                        topHeight += $subTopbar.outerHeight();
                    const $tabsBar = $("#stats-wall-tabs-menu");
                    if ($tabsBar.length)
                        topHeight += $tabsBar.outerHeight();
                    const padding = 16;
                    window.scrollTo({
                        top: $content.offset().top - topHeight - padding,
                        behavior: "smooth",
                    });
                    this.highlightTab(item.tabSelector)
                        .then(() => {
                        CS.Lag("TabMenuTabClick", 500, () => {
                            this.bindScrollEvent();
                        });
                    })
                        .catch((error) => {
                        throw error;
                    });
                }
                catch (error) {
                    console.error("Error while handling tab menu click", error);
                    this.unbindScrollEvent();
                    this.bindScrollEvent();
                }
            }
            onScroll() {
                const { instance } = TabMenu;
                if (instance.state === "ready") {
                    window.requestAnimationFrame(() => {
                        instance
                            .highlightMostVisibleContent()
                            .then(() => {
                            CS.Lag(`TabMenu`, 250, () => {
                                instance.state = "ready";
                            });
                        })
                            .catch(() => {
                            CS.Lag(`TabMenu-`, 250, () => {
                                instance.state = "ready";
                            });
                        });
                    });
                    instance.state = "busy";
                }
            }
            highlightMostVisibleContent() {
                return new Promise((resolve, reject) => {
                    try {
                        if (this.isDebug) {
                            this.log(`Highlighting most visible content...`);
                        }
                        let current = null;
                        for (let i = 0; i < this.items.length; i++) {
                            const item = this.items[i];
                            const visibility = this.visibilityOf($(item.contentSelector));
                            if (visibility.pixels === 0) {
                                continue;
                            }
                            if (!current) {
                                if (this.isDebug) {
                                    this.log(`No current content found, setting current...`);
                                }
                                current = {
                                    item,
                                    visibility,
                                };
                                continue;
                            }
                            if (visibility.full) {
                                if (this.isDebug) {
                                    this.log(`Content is fully visible, setting current...`);
                                }
                                current = {
                                    item,
                                    visibility,
                                };
                                continue;
                            }
                            if (visibility.pixels > current.visibility.pixels) {
                                if (this.isDebug) {
                                    this.log(`Content is more visible than current, setting current...`);
                                }
                                if (!current.visibility.full || visibility.full) {
                                    if (this.isDebug) {
                                        if (!current.visibility.full) {
                                            this.log(`Current content is not fully visible, proceeding...`);
                                        }
                                        else {
                                            this.log(`Content is fully visible, proceeding...`);
                                        }
                                    }
                                    current = {
                                        item,
                                        visibility,
                                    };
                                }
                                else {
                                    if (this.isDebug) {
                                        this.log(`Current content is fully visible and new content is not, aborting...`);
                                    }
                                    continue;
                                }
                                continue;
                            }
                        }
                        if (!current) {
                            if (this.isDebug) {
                                this.log(`No content found, aborting.`);
                            }
                            return resolve();
                        }
                        const { tabSelector } = current.item;
                        this.highlightTab(tabSelector)
                            .then(() => {
                            this.scrollToTab(tabSelector)
                                .then(() => {
                                return resolve();
                            })
                                .catch((error) => {
                                return reject(error);
                            });
                        })
                            .catch((error) => {
                            return reject(error);
                        });
                    }
                    catch (error) {
                        return reject(error);
                    }
                });
            }
            highlightTab(tabSelector) {
                return new Promise((resolve, reject) => {
                    try {
                        if (this.isDebug) {
                            this.log(`Highlighting tab "${tabSelector}"...`);
                        }
                        const $tab = $(tabSelector);
                        if (!$tab.length) {
                            if (this.isDebug) {
                                this.log(`No tab found, aborting.`);
                            }
                            return resolve();
                        }
                        const $tabs = $tab
                            .closest(".tabmenu.control-cs")
                            .find(".tab-menu-item");
                        if (!$tabs.length) {
                            if (this.isDebug) {
                                this.log(`No tabs found, aborting.`);
                            }
                            return resolve();
                        }
                        $tabs.removeClass("is-highlighted");
                        $tab.addClass("is-highlighted");
                        if (this.isDebug) {
                            this.log(`Tab highlighted.`);
                        }
                        return resolve();
                    }
                    catch (error) {
                        console.error(`Error while highlighting tab "${tabSelector}".`, error);
                        return reject(error);
                    }
                });
            }
            scrollToTab(tabSelector) {
                return new Promise((resolve, reject) => {
                    try {
                        if (this.isDebug) {
                            this.log(`Scrolling to tab "${tabSelector}"...`);
                        }
                        CS.Lag("TabMenuScroll", 150, () => {
                            const $tab = $(tabSelector);
                            if (!$tab.length) {
                                if (this.isDebug) {
                                    this.log(`No tab found, aborting.`);
                                }
                                return resolve();
                            }
                            const $tabmenu = $tab.closest(".tabmenu.control-cs");
                            if (!$tabmenu.length) {
                                if (this.isDebug) {
                                    this.log(`No tab menu found, aborting.`);
                                }
                                return resolve();
                            }
                            const $sectionMiddle = $tabmenu.closest(".section-middle");
                            const containerDomRect = $sectionMiddle[0].getBoundingClientRect();
                            const { left: containerLeft, right: containerRight } = containerDomRect;
                            const itemDomRect = $tab[0].getBoundingClientRect();
                            const { left: itemLeft, right: itemRight } = itemDomRect;
                            if (itemLeft < containerLeft) {
                                const $scrollingContainer = $tab.closest(".horizontal-scroller-content");
                                if (!$scrollingContainer.length) {
                                    return resolve();
                                }
                                const scrollLeft = itemLeft - containerLeft + $scrollingContainer.scrollLeft();
                                $scrollingContainer.animate({ scrollLeft }, 250);
                                return resolve();
                            }
                            else if (itemRight > containerRight) {
                                const $scrollingContainer = $tab.closest(".horizontal-scroller-content");
                                if (!$scrollingContainer.length) {
                                    return resolve();
                                }
                                const scrollLeft = itemRight - containerRight + $scrollingContainer.scrollLeft();
                                $scrollingContainer.animate({ scrollLeft }, 250);
                                return resolve();
                            }
                            else {
                                return resolve();
                            }
                        });
                    }
                    catch (error) {
                        console.error(`Error while scrolling to tab "${tabSelector}".`, error);
                        return reject(error);
                    }
                });
            }
            visibilityOf($content) {
                var _a, _b;
                try {
                    const id = $content.attr("id");
                    if (this.isDebug) {
                        if (id) {
                            this.log(`Analyzing visibility of content "${id}"...`);
                        }
                        else {
                            this.log(`Analyzing visibility of content...`);
                        }
                    }
                    if (!$content.length) {
                        if (this.isDebug) {
                            this.log(`No content found, aborting.`);
                        }
                        return {
                            full: false,
                            pixels: 0,
                        };
                    }
                    const rootMargin = {
                        top: 0,
                        bottom: 0,
                    };
                    const rect = $content[0].getBoundingClientRect();
                    const topHeight = 0;
                    const bottomHeight = 0;
                    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                    const adjustedViewportHeight = viewportHeight -
                        (topHeight + bottomHeight) +
                        ((_a = rootMargin === null || rootMargin === void 0 ? void 0 : rootMargin.bottom) !== null && _a !== void 0 ? _a : 0);
                    const top = ((_b = rootMargin === null || rootMargin === void 0 ? void 0 : rootMargin.top) !== null && _b !== void 0 ? _b : 0) * -1;
                    const topEdgeIsOverViewport = rect.top < top;
                    const topEdgeIsUnderViewport = rect.top > adjustedViewportHeight;
                    const bottomEdgeIsOverViewport = rect.bottom < top;
                    const bottomEdgeIsUnderViewport = rect.bottom > adjustedViewportHeight;
                    const isTopEdgeVisible = !topEdgeIsUnderViewport && !topEdgeIsOverViewport;
                    const isBottomEdgeVisible = !bottomEdgeIsOverViewport && !bottomEdgeIsUnderViewport;
                    if (isTopEdgeVisible && isBottomEdgeVisible) {
                        if (this.isDebug) {
                            this.log(`Analyze done: Content is fully visible.`);
                        }
                        return {
                            full: true,
                            pixels: rect.height,
                        };
                    }
                    const anyEdgeVisible = isTopEdgeVisible || isBottomEdgeVisible;
                    if (anyEdgeVisible) {
                        if (isTopEdgeVisible) {
                            if (this.isDebug) {
                                this.log(`Analyzing done: Top edge of content is visible.`);
                            }
                            return {
                                full: isBottomEdgeVisible,
                                pixels: adjustedViewportHeight - rect.top,
                            };
                        }
                        else {
                            if (this.isDebug) {
                                this.log(`Analyze done: Bottom edge of content is visible.`);
                            }
                            return {
                                full: isTopEdgeVisible,
                                pixels: rect.bottom - top,
                            };
                        }
                    }
                    else {
                        const isVisible = (topEdgeIsOverViewport && !bottomEdgeIsOverViewport) ||
                            (!topEdgeIsUnderViewport && bottomEdgeIsUnderViewport);
                        if (!isVisible) {
                            if (this.isDebug) {
                                this.log(`Analyze done: Content is not visible.`);
                            }
                            return {
                                full: false,
                                pixels: 0,
                            };
                        }
                        if (this.isDebug) {
                            this.log(`Analyze done: Content is partially visible and overflowing.`);
                        }
                        return {
                            full: true,
                            pixels: adjustedViewportHeight,
                        };
                    }
                }
                catch (error) {
                    console.error(`Error while analyzing visibility of content.`, error);
                    return {
                        full: false,
                        pixels: 0,
                    };
                }
            }
            log(...args) {
                CS.Helper.log("TabMenu", ...args);
            }
        }
        Controls.TabMenu = TabMenu;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=tabmenu.js.map
